module.exports = __webpack_public_path__ + "img/res-3.7c6b4732.png";